<template>
  <el-dialog
      :title="title"
      :visible.sync="visible"
      class="custom-el-wrapper"
      width="600px"
      @close="handlerCancel"
  >


    <el-form ref="form" :model="form" label-width="100px">

      <el-form-item label="收货人">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input v-model="form.phone"></el-input>
      </el-form-item>
      <el-form-item label="省">
        <el-input v-model="form.province_name"></el-input>
      </el-form-item>
      <el-form-item label="市">
        <el-input v-model="form.city_name"></el-input>
      </el-form-item>
      <el-form-item label="区县">
        <el-input v-model="form.town_name"></el-input>
      </el-form-item>
      <el-form-item label="街道/镇">
        <el-input v-model="form.street_name"></el-input>
      </el-form-item>
      <el-form-item label="详细地址">
        <el-input v-model="form.detail"></el-input>
      </el-form-item>

    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handlerCancel">取 消</el-button>
      <el-button type="primary" @click="handlerConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      form:{

      },
      visible: false,
      callback: null,
      title: '',
      func: null,
      assemble: null,
    }
  },
  mounted() {

  },
  methods: {
    open(title, value, func, assemble, callback) {
      this.title = title;
      this.form = value;
      this.order_no = value.order_no;
      this.account = value.account;
      this.func = func;
      this.assemble = assemble;
      this.callback = callback;
      this.visible = true;

    },
    handlerConfirm() {
      this.func({
        data: this.assemble(this.form),
        success: (res) => {
          this.callback(res);
          this.visible = false;
        },
      })
    },
    handlerCancel() {
      this.visible = false;
    },
  }
}
</script>

<style scoped>

</style>
